export default "__VITE_ASSET__748b0c6f__"